import { Component, OnInit } from '@angular/core';
import { UserManagementServiceService } from '../user-management-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from 'src/app/shared/snack-bar/snack-bar.component';
import { Router } from '@angular/router';
const editIconImage = '../../../../assets/images/edit.svg';
const deleteIconImage = '../../../../assets/images/delete-bin.svg';

@Component({
  selector: 'app-user-level',
  templateUrl: './user-level.component.html',
  styleUrls: ['./user-level.component.scss']
})
export class UserLevelComponent implements OnInit {
  constructor(
    private userManagementServiceService: UserManagementServiceService,
    private snackBar: MatSnackBar,
    private router: Router,

  ) {
    const pageAction = JSON.parse(sessionStorage.getItem('userPermission') || '[]');
    this.allowedAction = pageAction[0].authenicationJson.filter((el: any) => {
      if (el?.model === 'role') { return el; }
    });
   }
    allRoleDetails: any;
    allowedAction: any;

  totalCount = 0;

  action = [
    {
      actionType: 'edit', icon: 'fa fa-edit', disabled: false, toolTip: 'Edit',
      imgIcon: '../../../../assets/images/edit.svg', isPermission: false, label: 'Update', key: 'update'
    },
    {
      actionType: 'delete', icon: 'fa fa-trash', disabled: false, toolTip: 'Delete',
      imgIcon: '../../../../assets/images/delete-bin.svg', isPermission: false, label: 'Delete', key: 'delete'
    },
    {
      actionType: 'view', icon: 'fa fa-eye', disabled: false, toolTip: 'View',
      imgIcon: '../../../../assets/images/view-icon.svg', isPermission: true, label: 'View', key: 'view'
    },
  ];
  userTableHeading1 = [
    {title: '', code: 'User Role', key: 'role.name' , subKey: '', type: 'text', sort: true, },
    {title: '', code: 'Module', key: 'label' , subKey: '', type: 'text', sort: true},
    {title: '', code: 'Actions', key: 'action' , subKey: '', type: 'text', sort: false},
  ];

  ngOnInit(): void {
    this.action =  this.userManagementServiceService.actionTablePermission(this.action, this.allowedAction[0]);
    this.getAllRoleList();
  }

  redirectUserRoleCreate(): void{
    this.router.navigate(['/user-policies']);
  }
  tableAction(data: any, action: string): void {
    if (action === 'edit') {
      this.router.navigate(['/user-policies', data.role_id]);
    }
    if (action === 'delete') {
      this.deleteModule(data);
    }
    if (action === 'view'){
      const queryParams = {
        mode : 'view'
      };
      this.router.navigate(['/user-policies', data.role_id], { queryParams });
    }
  }

  deleteModule(data: any): void {
    const payload = {
        isActive : data.id ? false : true,
        role_name: data['role.name'] ? data['role.name'] : ''
      };
    this.userManagementServiceService.deleteRole(data?.id, payload).subscribe((res: any) => {
        if (res.success){
          this.openSnackBar([ 'Deleted Successfully '] , '', 'success');
          const page = data?.page ? data?.page : 1;
          this.getAllRoleList(page);
        }
      }, (error: any) => {
        this.openSnackBar([error?.message || 'Failed !'] , '', '');
      });
  }
  getAllRoleList(page= 1, limit= 10, sortingOrder: string= '', columnName: string= ''): void{
    this.userManagementServiceService.allRoleDetails(page, limit, sortingOrder, columnName).subscribe((res: any) => {
      if (res.success){
        this.allRoleDetails = JSON.parse(JSON.stringify(res.data));
        this.totalCount = res.total ? res.total : 0;
      }
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed !'] , '', '');
      this.allRoleDetails = [];
    });
  }
  clearSearchBox(event: any): void {
    this.getAllRoleList();
  }
  pageHandler(event: any): void{
    this.getAllRoleList(event?.page, event?.limit, event?.orderSorting, event?.key);
  }
  openSnackBar(message: any, action = '', className= 'parmary'): void {
    this.snackBar.open(message, action, {
    duration: 3000,
    panelClass: [className]
  });
  }
  sortTable(event: any): void {
    this.getAllRoleList(event.page, 10, event?.orderSorting, event?.key);
  }
}
